import { render, staticRenderFns } from "./BackgroundSettings.vue?vue&type=template&id=55af1e2c&scoped=true&"
import script from "./BackgroundSettings.vue?vue&type=script&lang=js&"
export * from "./BackgroundSettings.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundSettings.vue?vue&type=style&index=0&id=55af1e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af1e2c",
  null
  
)

export default component.exports